module.exports = __webpack_public_path__ + "static/media/3.011fc82d.PNG";